







































































































































































































































































































import mapMixin from '@/assets/ts/mixins/branches-mixin';
// import mapboxgl from 'mapbox-gl';
import BottomNavigation from '@/components/BottomNavigation.vue';
import TextFieldIcon from '@/components/shared/Text-Field-Icon.vue';
import BaseIcon from '@/components/BaseIcon.vue';
// import markerIcon from "../assets/images/icons/marker_icon.png"
// import '@/assets/css/mapbox-gl.css';
import 'leaflet/dist/leaflet.css';

export default {
  name: 'Branches',
  layout: 'bottom-bar',

  components: {
    BottomNavigation,
    TextFieldIcon,
    BaseIcon,
  },
  mixins: [mapMixin],
  data() {
    return {
      map: null,

      render: false,
      search: '',
      // map: {},
      markers: <
        {
          DepAddress: string;
          DepName: string;
          DepTel: string;
          DepartmentInfo_ID: string;
          city: string;
          datetime: any;
          distance: number;
          id: string;
          isActive: number;
          lat: string;
          long: string;
          platforms: string[];
        }[]
      >[],

      branchMarker: '',
      selectedBranch: '',
      searchedResultDrawer: false,
      addAddressDrawer: true,
      selectedCoord: '',
      isBranchSelected: false,
      isInputClearableVisible: false,
      isPermitted: true,
      visible: false,
      lat: '35.69980',
      lng: '51.33821',
      iconUrl: '~assets/images/icons/marker_icon.png',
      permissionStatus: '',
      iconName: {
        home: {
          name: 'fi-rr-home',
          color: '#acacac',
        },
        branches: {
          name: 'fi-sr-marker',
          color: '#003974',
        },
        store: {
          name: 'fi-rr-shop',
          color: '#acacac',
        },
        shoppingCart: {
          name: 'fi-rr-shopping-cart',
          color: '#acacac',
        },
        profile: {
          name: 'fi-rr-user',
          color: '#acacac',
        },
      },
    };
  },
  watch: {
    search: {
      handler(val) {
        try {
          val.length !== 0
            ? ((this as any).isInputClearableVisible = true)
            : ((this as any).isInputClearableVisible = false);
        } catch (error) {}
      },
    },
  },

  async mounted() {
    (this as any).$nextTick(() => {
      (this as any).map = (this as any).$refs.map.mapObject; // work as expected
      (this as any).map.setView([(this as any).lat, (this as any).lng]);

      (this as any).map.on('moveend', (e) => {
        const center = (this as any).map.getCenter().wrap();
      });
      (this as any).map.on('locationfound', (e) => {
        if (
          e.latlng.lat !== (this as any).lat &&
          e.latlng.lng !== (this as any).lng
        ) {
          (this as any).lng = e.latlng.lng;
          (this as any).lat = e.latlng.lat;
        }
      });
      (this as any).map.locate();
    });
    setTimeout(function () {
      window.dispatchEvent(new Event('resize'));
    }, 100);

    // if (mapboxgl.getRTLTextPluginStatus() !== 'loaded') {
    //   mapboxgl.setRTLTextPlugin(
    //     'https://cdn.parsimap.ir/third-party/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
    //     null
    //   );
    // }
    const bounds = [
      [53.6830157, 32.4207423], // Southwest coordinates
      // [-122.250481, 37.871651], // Northeast coordinates
    ];
    // this.render = true;
    // (this as any).map = new mapboxgl.Map({
    //   container: 'map',
    //   style: `https://api.parsimap.ir/styles/parsimap-streets-v11?key=${process.env.PMI_MAP_TOKEN}`,
    //   center: [(this as any).lng, (this as any).lat],
    //   zoom: 3.5,
    // });

    (this as any).showBranch();

    const p = this as any;

    // const geolocate = new mapboxgl.GeolocateControl({
    //   positionOptions: {
    //     enableHighAccuracy: true,
    //   },
    //   trackUserLocation: true,
    // });

    // (this as any).map.addControl(geolocate);
    // (this as any).map.on('load', function () {
    //   geolocate.trigger();
    //   // p.render = true;
    // });

    // (this as any).map.on('sourcedata', (e) => {
    //   (this as any).map.resize();
    //   p.render = true;
    // });
    const app = this as any;
    // geolocate.on('geolocate', function () {
    //   const userlocation = geolocate._lastKnownPosition;
    //   app.lat = userlocation.coords.latitude;
    //   app.lng = userlocation.coords.longitude;

    //   p.showBranch();
    // });
  },
  methods: {
    getIcon(branch) {
      if (branch === (this as any).selectedBranch) {
        console.log('in if');
        console.log(branch);
        console.log((this as any).selectedBranch);
        return require('../assets/images/icons/selected-marker-icon.svg');
      } else {
        return require('../assets/images/icons/marker-icon.svg');
      }
    },
    handleMarkerClick(e) {
      (this as any).flyToBranch(e);
      (this as any).selectedBranch = e;
      (this as any).visible = true;
      // (this as any).branchMarker.classList.remove('marker');
      // (this as any).branchMarker.classList.add('selected-marker');
      // (this as any).configureMarker(
      //   (this as any).branchMarker,
      //   (this as any).getPosition(e)
      // );
    },
    hideSearchDrawer() {
      (this as any).searchedResultDrawer = false;
    },
    clearInput() {
      (this as any).search = '';
    },

    async openDrawer() {
      (this as any).permissionStatus = await navigator?.permissions?.query({
        name: 'geolocation',
      });
      // console.log((this as any).permissionStatus);
      if ((this as any).permissionStatus !== undefined) {
        (this as any).permissionStatus.state === 'denied'
          ? ((this as any).isPermitted = false)
          : ((this as any).isPermitted = true);
      }
      (this as any).searchedResultDrawer = !(this as any).searchedResultDrawer;
      (this as any).visible = false;
    },
    getPosition(marker) {
      return [parseFloat(marker.long), parseFloat(marker.lat)];
    },
    async showBranch() {
      try {
        const response = await (this as any).fetchBranchWithDistance({
          lat: (this as any).lat.toString(),
          long: (this as any).lng.toString(),
        });
        if ((this as any).isResponseSuccess(response.status)) {
          // console.log('2');
        }
        (this as any).generateMarker('marker');
      } catch (error) {
        console.log('ERROR', error);
      }
    },
    generateMarker() {
      const p = this as any;
      (this as any).branchesWithDistance.forEach((branch) => {
        // (this as any).markers.push((this as any).getPosition(branch));
        (this as any).markers.push(branch);
        const el = document.createElement('div');
        el.classList.add('marker');
        console.log(branch);
        // const marker = new mapboxgl.Marker(el)
        //   .setLngLat((this as any).getPosition(branch))
        //   .addTo((this as any).map);
        (this as any).branchMarker = el;
        // marker.getElement().addEventListener('click', () => {
        //   // if ((this as any).branchMarker !== el) {
        //   (this as any).selectedBranch = branch;
        //   (this as any).visible = true;
        //   (this as any).branchMarker.classList.remove('marker');
        //   (this as any).branchMarker.classList.add('selected-marker');
        //   (this as any).configureMarker(
        //     (this as any).branchMarker,
        //     (this as any).getPosition(branch)
        //   );
        //   (this as any).flyToBranch(branch);
        //   // }
        // });
      });
    },
    configureMarker(el, coord) {
      // new mapboxgl.Marker(el).setLngLat(coord).addTo((this as any).map);
    },
    chooseBranch(branch) {
      (this as any).selectedBranch = branch;
      (this as any).searchedResultDrawer = !(this as any).searchedResultDrawer;
      (this as any).visible = true;
      (this as any).branchMarker.classList.remove('marker');
      (this as any).branchMarker.classList.add('selected-marker');
      (this as any).configureMarker(
        (this as any).branchMarker,
        (this as any).getPosition(branch)
      );
      (this as any).flyToBranch(branch);
    },
    flyToBranch(coord) {
      console.log('fly to');
      console.log(coord);
      (this as any).map.flyTo([coord.lat, coord.long], 15);
      // (this as any).map.flyTo({
      //   // bearing: 10,
      //   // curve: 20,
      //   //speed: 0.2,
      //   offset: [0, -170],
      //   center: [coord.long, coord.lat + 10],
      //   zoom: 15,
      //   essential: false,
      // });
    },
    closeInformationSection(branch) {
      (this as any).branchMarker.classList.remove('selected-marker');
      (this as any).branchMarker.classList.add('marker');
      (this as any).generateMarker();
      (this as any).visible = !(this as any).visible;
    },
  },
};
